// Simple nanoid/non-secure polyfill for React Navigation
// This is used to generate unique IDs for navigation

// Simple non-secure nanoid implementation
function nanoid(size = 21) {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  for (let i = 0; i < size; i++) {
    id += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
  }
  return id;
}

// Export the nanoid function as both a named export and default export
module.exports = nanoid;
module.exports.nanoid = nanoid; 